export const REPORT_DATA_KEYS = [
  'periodFrom',
  'periodTo',
  'taxYear',
  'slGroupType',
  'slGroupItem',
  'countryTaxType',
  'bookType',
  'reportingCurrency',
  'aggregationDroplistValue',
];

